import React, {useState} from "react";
import {Form, NavLink, Outlet, useRouteLoaderData} from "react-router-dom";
import {
    Box,
    Button,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton, Stack
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import api from "../../../../hooks/useApi";
import {showSnackbar} from "../../../../components/snackbarUtils";
import DeleteIcon from "@mui/icons-material/Delete";
import PageTitle from "../../../../components/PageTitle";

export default function ObjectTariffs() {
    const layoutLoader = useRouteLoaderData("obj_layout");
    const hotelObjs = layoutLoader?.hotelObj?.children_obj || []; // Теперь массив
    const hotelObj = layoutLoader?.hotelObj || {};

    const [expanded, setExpanded] = useState(null);

    const handleExpand = (panel) => (_, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };

    const handleEditPrice = (price) => {
        console.log("Редагування ціни: ", price);
    };

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleDelete = async (priceId) => {
        try {
            const response = await api.delete(`/api/HotelPrice/${priceId}/`);

            if (response.status === 204 || response.statusText === 'No Content') {
                showSnackbar("Ціна успішно видалено!", "success", {
                    sx: {backgroundColor: "#1de416", color: "white"}
                });
                await sleep(1500);
                window.location.href = `/object/${hotelObj.id}/tariffs`;
            } else {
                showSnackbar("Не вдалося видалити ціну!", "error", {
                    sx: {backgroundColor: "#b10000", color: "white"}
                });
            }
        } catch (error) {
            showSnackbar(`Не вдалося видалити ціну! ${error}`, "error", {
                sx: {backgroundColor: "#b10000", color: "white"}
            });
        }
    };

    return (
        <Box sx={{width: "100%", p: 3}}>
            <PageTitle title={`Тарифи об'єкта: ${hotelObj?.name || hotelObj?.id || "ID"}`} />
            {hotelObjs.length === 0 ? (
                <Typography variant="body1" color="textSecondary">
                    Підоб'єкти відсутні
                </Typography>
            ) : (
                hotelObjs.map((hotelObj) => (
                    <Box key={hotelObj.id} sx={{mb: 4, borderBottom: "2px solid #ddd", pb: 2}}>
                        <Typography variant="h5" gutterBottom>
                            {hotelObj?.name || "Назва підоб'єкту не знайдена"}
                        </Typography>
                        <p>
                            {hotelObj?.service_name || "Сервісне ім'я не знайдено"}
                        </p>
                        <p style={{
                            fontSize: "12px",
                            color: "red",
                            fontWeight: "bold",
                            textAlign: "left",
                            marginTop: "10px"
                        }}>
                            * Увага! Для змін цін залежних тарифів, необхідно змінювати ціну базового тарифу.
                        </p>

                        {hotelObj.rates?.length > 0 ? (
                            hotelObj.rates.map((rate) => (
                                <Box key={rate.id} sx={{mb: 2}}>
                                    {/* Заголовок тарифа */}
                                    <Box
                                        sx={{
                                            backgroundColor: "#f5f5f5",
                                            p: 2,
                                            borderRadius: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 1.5,
                                            flexWrap: {xs: "wrap", sm: "nowrap"}
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                flex: "1 1 auto",
                                                minWidth: 0,
                                                whiteSpace: {xs: "normal", sm: "nowrap"},
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}
                                        >
                                            {rate.name}{" "}
                                            <Typography component="span" variant="body2"
                                                        sx={{fontSize: "0.8rem", color: "#757575"}}>
                                                {rate.active ? "(Тариф активний)" : "(Тариф не активний)"}
                                            </Typography>
                                        </Typography>

                                        <Button
                                            component={NavLink}
                                            variant="outlined"
                                            to={`${rate.id}/edit?children_id=${hotelObj.id}&rate_id=${rate.id}`}
                                            startIcon={<EditIcon/>}
                                            sx={{flexShrink: 0, width: {xs: "100%", sm: "auto"}, mt: {xs: 1, sm: 0}}}
                                        >
                                            Редагувати
                                        </Button>
                                    </Box>


                                    {/* Цены */}
                                    {rate.base_rate_name === "base" ? (
                                        <Accordion expanded={expanded === rate.id} onChange={handleExpand(rate.id)}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                                <Typography>Ціни тарифу</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <TableContainer component={Paper} sx={{overflowX: "auto"}}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Назва ціни</TableCell>
                                                                <TableCell>Період</TableCell>
                                                                <TableCell>Ціна</TableCell>
                                                                <TableCell>Податок</TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.values(
                                                                rate.prices.reduce((acc, price) => {
                                                                    if (!acc[price.price_id]) {
                                                                        acc[price.price_id] = {...price, count: 1};
                                                                    } else {
                                                                        acc[price.price_id].count += 1;
                                                                    }
                                                                    return acc;
                                                                }, {})
                                                            ).map((price) => (
                                                                <TableRow key={price.price_id}>
                                                                    <TableCell>{`Ціна ${price.count > 1 ? `(×${price.count})` : ""}`}</TableCell>
                                                                    <TableCell>{`${price.period_start} - ${price.period_end}`}</TableCell>
                                                                    <TableCell>{price.price} грн</TableCell>
                                                                    <TableCell>{price.tax} {price.another_amount_units}</TableCell>
                                                                    <TableCell>
                                                                        <Stack
                                                                            direction={{xs: "column", sm: "row"}}
                                                                            spacing={1}
                                                                            alignItems={{xs: "stretch", sm: "center"}}
                                                                        >
                                                                            <Button
                                                                                size="small"
                                                                                component={NavLink}
                                                                                variant="outlined"
                                                                                to={`${rate.id}/edit_price?children_id=${hotelObj.id}&price_id=${price.price_id}`}
                                                                                startIcon={<EditIcon/>}
                                                                            >
                                                                                Редагувати
                                                                            </Button>
                                                                            <Button
                                                                                size="small"
                                                                                onClick={() => handleDelete(price.price_id)}
                                                                                variant="outlined"
                                                                                color="error"
                                                                                startIcon={<DeleteIcon/>}
                                                                            >
                                                                                Видалити
                                                                            </Button>
                                                                        </Stack>
                                                                    </TableCell>

                                                                </TableRow>
                                                            ))}
                                                            <Button component={NavLink}
                                                                    variant="contained"
                                                                    to={`add_price?children_id=${hotelObj.id}&rate_id=${rate.id}`}
                                                                    startIcon={<EditIcon/>}
                                                            >
                                                                Додати ціну
                                                            </Button>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>
                                    ) : (
                                        <Typography variant="body2" sx={{mt: 1, color: "#757575"}}>
                                            Ціни прив'язані до тарифу <strong>{rate.base_rate_name}</strong>
                                        </Typography>
                                    )}
                                </Box>
                            ))
                        ) : (
                            <Typography variant="body1" color="textSecondary">
                                Тарифи відсутні
                            </Typography>
                        )}
                        <Button component={NavLink}
                                variant="contained"
                                to={`new?children_id=${hotelObj.id}`}
                                color="primary"
                                startIcon={<EditIcon/>}
                        >
                            Додати тариф
                        </Button>
                    </Box>
                ))
            )}
            <Outlet/>
        </Box>
    )
        ;
}
